import { type CanMatchFn } from '@angular/router';

/** Реестр дашбордов: добавление — строка здесь плюс маршрут в `app.routes.ts`. */

export interface DashboardEntry {
  /** Путь маршрута без ведущего слеша. */
  readonly path: string;
  readonly label: string;
  readonly caption: string;
  readonly icon: string;
  /** Логотип компании — показывается в шапке вместо логотипа сервиса. */
  readonly logo: string;
  /** Включает фирменную шапку и строку фильтров VASTA Отель Менеджмент. */
  readonly brand: 'vasta-hotel-management';
  /** Дашборд ещё не сделан — карточка показывается, но не кликается. */
  readonly ready: boolean;
  /** Есть живой источник, кроме заглушки: показывать переключатель «Демо / Сервер». */
  readonly serverSource: boolean;
  /** Скрыт целиком: нет на главной, по прямой ссылке — на главную. */
  readonly hidden?: boolean;
}

export const DASHBOARDS: readonly DashboardEntry[] = [
  {
    path: 'dashboards/manager-flash',
    label: 'Manager Flash',
    caption: 'Доход, загрузка и выполнение плана',
    icon: '@tui.zap',
    logo: '/icons/vasta-logo.svg',
    brand: 'vasta-hotel-management',
    ready: true,
    serverSource: true,
  },
  {
    path: 'dashboards/restaurant-flash',
    label: 'Restaurant Flash',
    caption: 'Рестораны и бары при отелях',
    icon: '@tui.utensils-crossed',
    logo: '/icons/vasta-logo.svg',
    brand: 'vasta-hotel-management',
    ready: true,
    serverSource: true,
  },
  {
    path: 'dashboards/aquapark-flash',
    label: 'Aquapark Flash',
    caption: 'Аквапарк: билеты, гости и допуслуги',
    icon: '@tui.waves',
    logo: '/icons/vasta-logo.svg',
    brand: 'vasta-hotel-management',
    ready: true,
    serverSource: false,
    /* Пока на демо-данных: сервер аквапарка подключается в другой ветке. */
    hidden: true,
  },
];

/** Подпись компании над её дашбордами на главной. */
export const BRAND_LABELS: Readonly<Record<DashboardEntry['brand'], string>> = {
  'vasta-hotel-management': 'ВАСТА Отель Менеджмент',
};

/** Дашборды, которые видны пользователю. */
export const VISIBLE_DASHBOARDS = DASHBOARDS.filter((entry) => entry.hidden !== true);

/** Скрытый дашборд маршрут не находит, и адрес уходит на главную. */
export const dashboardVisible: CanMatchFn = (route) =>
  findDashboard(route.path ?? '')?.hidden !== true;

/** Дашборд, которому принадлежит адрес. */
export function findDashboard(url: string): DashboardEntry | undefined {
  const path = url.split('?')[0]?.replace(/^\//, '') ?? '';

  return DASHBOARDS.find((entry) => path.startsWith(entry.path));
}
